module.exports = __webpack_public_path__ + "img/p_sz_18.b0435198.png";